import { useState } from 'react'
import { GuideImplementationCarousel, HubspotBrochureDownload } from '.'
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'

const GuideDetails = (props) => {
  return (
    <>
      <section className="bannerAreaN whiteBackground BannerDeatils mb-5">
        <div className="detailsPageSection">
          <img
            src="https://res.cloudinary.com/vantagecircle/image/upload/v1709807887/VantageFit/2023/background-new.webp"
            alt="corporate wellness"
            className="img-responsive"
            width="1435"
            height="500"
          />
        </div>
        <div className="BannerContent">
          <div className="headingBannerM container customCampaignContainer text-left ">
            <div className="row">
              <div className=" col-lg-8 col-xs-12 col-md-6 col-sm-12 detailbanner">
                <h1> A Comprehensive Guide to Corporate Wellness Programs</h1>
                <p className="colorwhite mx-auto hero-para font-weight-semibold no-br">
                  This definitive guide to corporate wellness programs will help you learn all there is to know about
                  running a successful wellness program in your workplace.
                </p>
                <div className="mtb25">
                  <a href="#downloadForm" className="vfitwhitecta scrollToDownload">
                    {' '}
                    Get your Copy{' '}
                  </a>
                </div>
              </div>
              <div className="col-lg-4  col-xs-12 col-md-6 col-sm-12 pclr">
                <img
                  alt="Corporate wellness guide"
                  className="mobileDisplay lozad"
                  loading="lazy"
                  src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/guideebook.png"
                  width="263"
                  height="372"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contentmainN ptb0">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>What is a Corporate Wellness Program?</li>
                  <li>Why are Corporate Wellness Programs Important?</li>
                  <li>How to encourage workplace wellness?</li>
                  <li>Major Companies which use wellness programs</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <GuideImplementationCarousel />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="ef5dcbe8-e1c1-4142-9242-606f84ae6e0d" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default GuideDetails
